export default __webpack_public_path__ + "static/media/progress.c16e84ee.gif";